import { useMutation } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';
import { executeCaptcha } from './executeCaptcha';
import { toast } from 'react-toastify';
import { BrokerData } from '@/types';
import { GET_BROKER_CONTACTS } from '@/constants';

type SuccessParams = {
  mobile?: string;
  phone?: string;
  email?: string;
};

export const useGetBrokerContactsInfo = (onSuccess: (data: SuccessParams) => void) =>
  useMutation<BrokerData, AxiosError, { objectId: string }>({
    mutationKey: ['broker-contacts-info'],
    mutationFn: async ({ objectId }) => {
      const captchaToken = await executeCaptcha();

      const { data } = await axios.post<BrokerData>(`${GET_BROKER_CONTACTS}/${objectId}`, {
        captchaToken,
      });

      return data;
    },
    onSuccess: (response) => {
      const { contactPhone, contactMobile, contactEmail } = response;

      onSuccess({
        mobile: contactMobile?.number,
        phone: contactPhone?.number,
        email: contactEmail,
      });
    },
    onError: (error) => {
      toast.error(error.message);
      console.error(error);
    },
  });
